const notifications = {
  error: {
    gpsBusinessLogic: {
      newInspection:
        "It is not possible to create a new inspection. Distance from Equipment in Km:",
      permission: "Permission Denied. Check User privileges.",
      position: "Location information is unavailable.",
      timeout: "The request to get user location timed out.",
      unknown: "An unknown error occurred."
    },
    userProfile: {}
  },
  success: {
    inspectionProfile: {
      multimediaUpload: "The file was uploaded"
    }
  },
  messages: {
    updateAvailable: "New version available!",
    getOurApp:
      "Get our app. It won't take up space on your device and also works offline!",
    getOurAppIphone1: "Get our app on your iPhone: Tap",
    getOurAppIphone2: "and then Add to HomeScreen"
  },
  buttons: {
    dismiss: "Dismiss",
    install: "Install"
  }
};
export default notifications;
